import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  Renderer2,
} from "@angular/core";
import { UtilityServiceService } from "../../services/utility-service.service";
import { CarrierService } from "../../services/carrier.service";
import { AuthWebService } from "../../services/authweb.service";
import { CarrierworkflowService } from "../../services/carrierworkflow.service";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { DialogService } from "ng2-bootstrap-modal";
import { AlertComponent } from "../../popup/alert.component";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { DocumentsServiceService } from "../../services/documents-service.service";
import { DomSanitizer } from "@angular/platform-browser";
import { CarrierAccountService } from "../../services/carrier-account.service";
import { CompanydetailsComponent } from "app/companydetails/companydetails.component";
import { UploaddocumentComponent } from "app/uploaddocument/uploaddocument.component";
import { environment } from "environments/environment";
import { SharedModule } from 'app/shared.module';
import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";
import { WorkflowService } from "app/services/workflow.service";
import { ProcessActivityDTO } from '../../models/processactivitydto'


@Component({
  selector: "submission",
  templateUrl: "./submission.component.html",
  styleUrls: ["./submission.component.css"],
})
export class SubmissionComponent implements OnInit {
  @Input("ctrlData") ctrlData: any;
  isDisabled = false;
  public isLoading = false;
  caConfirmObj: any = {};
  carrierAccountObj: any = {};
  userInfo: any;
  decl_date = new Date();
  declaration = "";
  form: any;
  status_id: number;
  email_body = "";
  accountNumber;
  message = "Submitting your request, please wait...";
  message1 = "Unable to submit";
  feedback: any = {};
  isLoadingImg: boolean;
  doc: any;
  isPDF: number;
  debtoraccount: any = {};
  showDocs: boolean = false;
  isApproved: boolean = false;
  accountBalance: number;
  subject = "Acknowledgement of carrier account submission";
  isExternalRole: boolean = true;
  submitButtonText = "Submit";
  termsFlag: boolean;
  agreesOCAS: boolean = true;
  termsOCAS: boolean = true;
  submitTitle = "Submit your carrier account's details";
  turnOverBrand: any = {
    1: "Less than R1 Mil",
    2: "Between R1 Mil and R5 Mil",
    3: "Above R5 Mil",
  };
  carrierStatus = 0;
  ocasCarrierId;
  selectedTab = 0;

  activityDTO = new ProcessActivityDTO();

  @Input() hideBackButton: boolean = false;
  @ViewChild("top") public carrierTypeSection: ElementRef;
  @Output() previousStep = new EventEmitter<number>();
  @ViewChild("btnSubmit") btnSubmit: ElementRef;
  @ViewChild("uAgreed") declarationCheckbox: ElementRef;

  goBack() {
    this.previousStep.emit(3);
  }

  constructor(
    private carrierAccountService: CarrierAccountService,
    private documentService: DocumentsServiceService,
    private router: Router,
    private carrierService: CarrierService,
    public utility: UtilityServiceService,
    private authWebService: AuthWebService,
    private activateRoute: ActivatedRoute,
    private toastService: ToastNotificationService,
    private renderer: Renderer2,
    private wService: CarrierworkflowService,
    private msg: ToastrService,
    private sanitizer: DomSanitizer,
    private workflowService: WorkflowService
  ) {}

  ngOnInit() {
    if (this.router.url.indexOf("carrier") > 0) {
      let id: any = this.activateRoute.params["_value"].id;
      this.ocasCarrierId = id;
      this.utility.carrierId = id;
    }
    if(this.router.url.includes('carrier/account/add')){
      this.ocasCarrierId =  this.utility.ctrlPages[this.utility.acc.First].carrierId;
      this.utility.carrierId = this.utility.ctrlPages[this.utility.acc.First].carrierId;
    }

    //this.utility.carrierObject=this.ctrlData;
    this.getCarrierInfo(this.utility.carrierId);
    this.caConfirmObj.Demographic = null;
    this.retrieveSubmitStatus();
    this.getConfirmDetails();
    this.setConfigdata();
    this.createForm();
    this.setDeclareReadOnly();
    this.getDebtorAccount(this.activateRoute.params["_value"].id);

    if (!this.authWebService.userData.Roles[0].IsExternalRole) {
      this.isExternalRole = false;
      this.isDisabled = true;
      this.submitButtonText = "Update";
      this.submitTitle = "Update carrier details";
    }

    this.moveToTopSection();
  }
  public moveToTopSection(): void {
    this.carrierTypeSection.nativeElement.scrollIntoView({
      behavior: "smooth",
    });
  }
  moveToContact() {
    document.getElementById("jumpToInfo").click();

    setTimeout(() => {
      document.getElementById("move-to-contact").click();
    }, 1000);
  }

  moveToCarrierType() {
    document.getElementById("jumpToInfo").click();
    setTimeout(() => {
      document.getElementById("move-to-carrier-type").click();
    }, 1000);
  }

  moveToAddress() {
    document.getElementById("jumpToInfo").click();
    setTimeout(() => {
      document.getElementById("move-to-address").click();
    }, 1000);
  }

  moveToComplance() {
    document.getElementById("jumpToInfo").click();

    setTimeout(() => {
      document.getElementById("move-to-compliance").click();
    }, 1000);
  }

  moveToDemo() {
    document.getElementById("jumpToInfo").click();

    setTimeout(() => {
      document.getElementById("move-to-demo").click();
    }, 1000);
  }

  getUpdateBalance() {
    if (this.caConfirmObj.carrier_status === "Approved") {
      this.carrierService
        .getUpdateBalance(this.carrierAccountObj.carrier_account_id)
        .subscribe((res) => {});
    }
  }

  getDebtorAccount(id: number) {
    this.carrierAccountService.getCarrierAccountByID(id).subscribe(
      (result) => {
        this.carrierAccountObj = result;
        this.getUpdateBalance();
      },
      (error) => {
        console.log("Error occured: " + error);
      }
    );
  }

  getConfirmDetails = () => {
    this.isLoading = true;
    this.message = "Retrieving carrier account information, please wait...";
    let carrierId: any = this.utility.carrierId;
    if (this.utility.ctrlPages[this.utility.acc.First].carrierId == undefined) {
      carrierId = this.utility.carrierId;
    } else {
      if (this.utility.carrierId == undefined) {
        carrierId = this.utility.ctrlPages[this.utility.acc.First].carrierId;
      }
    }
    this.carrierService.getAccountConfirmationDetailsById(carrierId).subscribe(
      (result) => {
        this.caConfirmObj = result;
        if (parseInt(this.caConfirmObj.account_balance) != 0) {
          this.caConfirmObj.account_balance = -parseInt(
            this.caConfirmObj.account_balance
          );
          this.accountBalance = this.caConfirmObj.account_balance;
        }
        this.caConfirmObj.documents = this.caConfirmObj.documents.filter(x => x.docType !== "Supporting documents for motivation of service" && x.group_code !== "OCASDRIVER" && x.group_code !== "OCASRCP");

         console.log( this.caConfirmObj);
        this.isLoading = false;
        this.showDocs = true;
      },
      (error) => {
        this.isLoading = false;
        //console.log(error);
      }
    );
  };
  back() {
    // this.utility.activeTab = 2;
    document.getElementById("jumpToOcasID").click();
  }
  gotoDocs(){
    document.getElementById("jumpToDoc").click();
  }
  setConfigdata = () => {
    this.userInfo = this.authWebService.userInfo();
    let declaration: any;
    if (this.authWebService.userData) {
      declaration = this.authWebService.userData.Configurations.find(
        (config) => config.Code == "HTMLDec1"
      );
    }
    this.declaration = declaration.Value;
  };

  setDeclareReadOnly() {
    if (!this.utility.isBtnVisible) {
      this.form.get("termsFlag").disable();
      this.form.get("termsFlag").value = true;
    }
  }
  createForm = () => {
    this.form = new FormGroup({
      carrier_id: new FormControl(
        this.utility.ctrlPages[this.utility.acc.First].carrierId
      ),
      status_id: new FormControl(this.status_id),
      submittedOn: new FormControl(new Date()),
      email_body: new FormControl(this.email_body),
      username: new FormControl(this.userInfo.username),
      emailAddress: new FormControl(this.userInfo.emailAddress),
      subject: new FormControl(this.subject),
    });
    this.form.patchValue(this.utility.defaults);
  };

  onSubmit = (obj: any) => {
    if (!this.form.valid && this.isExternalRole) {
      return this.toastService.error(
        "Please click the declaration box",
        "Declaration"
      );
    }

    this.isLoading = true;
    this.message = "Saving...";
  
    if (this.isExternalRole) {
      this.carrierService.processSubmission(obj).subscribe(
        (result) => {
          this.isLoading = false;
          if (result == true) {
            //  this.showSuccess(`Carrier Account with registration number  ${ this.caConfirmObj.registration_number } submitted successfully.`);
            //this.dialogService.addDialog(AlertComponent, { title: `Carrier Account Submission`, message: `Carrier Account with registration number  ${this.caConfirmObj.registration_number} submitted successfully.`, bold: `${this.caConfirmObj.registration_number}` });
            
            if (this.utility.carrierObject.data.status_id == 1) {        
              this.initiateWorkflow();
            } else {
              this.processWorkflow();
            }

            this.utility.activeTab = 1;
            this.router.navigateByUrl(
              `congratulations/${this.caConfirmObj.carrier_account_id}`
          );
            // if(this.agreesOCAS){
            //   this.router.navigateByUrl(
            //       `ocas-stepper/${obj.carrier_id}`
            //   );
            // }else{
            //   this.router.navigateByUrl(
            //       `congratulations/${this.caConfirmObj.carrier_account_id}`
            //   );
            // }
          } else {
            this.showError(
              `Submission for  ${this.caConfirmObj.registration_number} failed. Please contact the system administrator if the problem persists.`
            );
          }
        },
        (error) => {
          this.isLoading = false;
          this.showError(
            `Submission for  ${this.caConfirmObj.registration_number} failed. Please contact the system administrator if the problem persists.`
          );
          //this.dialogService.addDialog(AlertComponent, { title: `Carrier Account Submission`, message: `Submission for  ${this.caConfirmObj.registration_number} failed.Please contact the system administrator if the problem persists.`, bold: `${obj.registered_name}` });
        }
      );
    } else {
      this.isLoading = false;
      return this.msg.info("Details updated successfully", "Review");
    }
  };

  retrieveSubmitStatus = () => {
    if (this.authWebService.userData) {
      this.status_id = +this.authWebService.userData.Configurations.find(
        (config) => config.Code == "AccountStatus2"
      ).Value;
      const emailConfig: any = this.authWebService.userData.Configurations.find(
        (config) => config.Code == "SubmitEmail1"
      );
      this.email_body = emailConfig.Value;
      emailConfig.Description;
      this.subject = emailConfig.Description;
    }
  };

  validateSubmit(control: FormControl) {
    let checked = control.value;
    if (!checked) {
      return {
        checked: {
          saIdnumer: checked,
        },
      };
    }
    return null;
  }
  startWorkflow() {
    this.wService
      .startCreateCarrierWorkflow(
        this.utility.ctrlPages[this.utility.acc.First].carrierId
      )
      .subscribe(
        (result) => {
          this.feedback = result;
        },
        (error) => {
          //console.log(error);
        }
      );
  }

  showSuccess(msg) {
    this.msg.success(msg, "Carrier Account Submission");
  }

  showError = (msg) => {
    this.msg.error(msg, "Carrier Account Submission");
  };
  viewDoc(fileName) {
    if (fileName != undefined) {
      this.isLoadingImg = true;
      this.doc = null;
      this.isPDF = 0;
      let id = fileName.substring(fileName.indexOf("#") + 1);
      document.getElementById("btnView").click();
      if (fileName.includes(".pdf")) {
        this.documentService.downloadpdf(id).subscribe((x) => {
          let objectURL = URL.createObjectURL(x);
          this.doc = objectURL;
          this.isPDF = 1;

          this.isLoadingImg = false;
        });
        return;
      }
      this.documentService.download(id).subscribe((x) => {
        let objectURL = URL.createObjectURL(x);
        this.isPDF = 2;
        this.doc = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        this.isLoadingImg = false;
      });
    }
  }
  getCarrierInfo(carrierId) {
    this.carrierService.carrierInfo(carrierId).subscribe((res: any) => {
      this.accountNumber = res.AccountNumber;
      this.ctrlData.data = res;
      this.ctrlData.carrierId = carrierId;
      this.utility.carrierObject = this.ctrlData;
      var button = document.getElementById("btnSubmit") as HTMLButtonElement;
      if (this.ctrlData.data.status_id == 51) {
        this.isApproved = true;
        button.disabled = true;
      } else {
        this.isApproved = false;
        button.disabled = false;
      }
    });
  }

  checkBalanceBeforeSubmit() {
    if (this.accountBalance == null) return true;
    if (this.accountBalance < 1) return true;
    else return false;
  }
  isAccountBalanceNullOrZero() {
    if (this.accountBalance == null) return true;
    if (this.accountBalance < 1) return true;
    else return false;
  }
  close() {
    if(!this.utility.isPermitEnquiry){
      if (this.ctrlData.xstatus == 1 && !this.isExternalRole) {
        this.utility.isProcessAccounts = true;
      }
      this.utility.landingPage();
    }else{      
      this.router.navigateByUrl("maintain-view-permit");
    }
    
  }

  checkTerms(event) {
    if (event.target.checked) {
      this.termsFlag = true;
    } else {
      this.termsFlag = false;
    }
  }
  checkOCASAgreement(event) {
    if (event.target.checked) {
      this.agreesOCAS = true;
    } else {
      this.agreesOCAS = false;
    }
  }
  disbledBtn() {
    let dueAmt: any = 0;
    if (!this.termsFlag) {
      return true;
    } else {
      // if (this.vehicles.length > 0) {
      let acntBal: any = 0;

      if (acntBal < dueAmt) {
        return true;
        // }
      } else {
        return false;
      }
    }
  }

    //#region Workflow
    initiateWorkflow() {
      this.workflowService.initiateCarrierWorkflow(this.utility.ctrlPages[this.utility.acc.First].carrierId)
        .subscribe(
          async (result: any) => {
            console.log(result);
          },
          (error) => {
            this.isLoading = false;
          }
        );
    }
  
    processWorkflow() {
      this.workflowService.getApplicationActivity(this.utility.ctrlPages[this.utility.acc.First].carrierId)
      .subscribe(
        async (result: any) => {
          if(!result['status']){
            if(result.userAssigned == this.userInfo.username){
              this.setActivityData(result)
            }
          }
        },
        (error) => {
        }
      );
    }
  
    setActivityData(result){
  
      this.activityDTO.Activityid = result.id;
      this.activityDTO.Rolefromid = result.roleAssignedId;
      this.activityDTO.Userfrom = result.userAssigned;
      this.activityDTO.Actionid = 2;
      this.activityDTO.Actionuser = this.userInfo.username;
      this.activityDTO.Comment = "";
      this.activityDTO.Isfinalapproval = false;
      this.activityDTO.RequiresMoreInfo = false;
  
      this.workflowService.processActivity(this.activityDTO, 'carrier')
        .subscribe(
          (resp) => {},
          (error) => {
            console.log(error);
            this.isLoading = false;
          });     
    }
  
    //#region

  // ngAfterViewInit() {
  //   const declarationCheckbox = this.declarationCheckbox.nativeElement;
  //   const submitButton = this.btnSubmit.nativeElement;

  //   this.renderer.listen(declarationCheckbox, 'change', () => {
  //     if (declarationCheckbox.checked) {
  //       submitButton.removeAttribute('disabled');
  //     } else {
  //       submitButton.setAttribute('disabled', 'true');
  //     }
  //   });
  // }
}
